<template lang="pug">
  div
    .heading Ping
    .subtitle This page allows you to send ping requests to a specific address.
    ICMPEcho
</template>
<script>
import ICMPEcho from "@/components/ICMPEcho";

export default {
  components: { ICMPEcho: ICMPEcho },
};
</script>
